import styled from '@emotion/styled';
import type { ButtonProps, PopoverOrigin } from '@mui/material';
import { Button } from '@mui/material';
import Menu from '@mui/material/Menu';
import React from 'react';
import { withPrefetch } from '../../../../../../components/hocs';
import { prefetchGetPricingTemplates } from '../../../../../../hooks/requests/use-pricing-template';
import { useMenu } from '../../../../../../hooks/use-menu';

const StyledMenu = styled(Menu)`
  margin-top: 8px;
  .MuiPaper-root {
    padding: 0;
    box-shadow: 0px 8px 16px 0px #0c124514;
    border: 1px solid #f0f4f6;
  }
`;

type AddItemMenuButtonProps = {
  cta: React.ReactNode;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
} & ButtonProps;

const AddItemMenuButton: React.FC<AddItemMenuButtonProps> = ({
  children,
  className,
  cta,
  anchorOrigin,
  transformOrigin,
  ...props
}) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        className={className}
        onClick={handleMenuOpen}
        disableElevation
        {...props}
      >
        {cta}
      </Button>

      <StyledMenu
        anchorOrigin={
          anchorOrigin ?? {
            vertical: 'bottom',
            horizontal: 'center',
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical: 'top',
            horizontal: 'center',
          }
        }
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        slotProps={{
          paper: {
            elevation: 1,
            sx: (theme) => ({
              width: '282px',
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: '8px',
              maxHeight: 300,
            }),
          },
        }}
      >
        {children}
      </StyledMenu>
    </>
  );
};

const AddItemMenuButtonWithPrefetch = withPrefetch(AddItemMenuButton, prefetchGetPricingTemplates);

export { AddItemMenuButtonWithPrefetch as AddItemMenuButton };
